import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-password-reset-email",
	templateUrl: "./password-reset-email.component.html",
	styleUrls: ["./password-reset-email.component.css"],
})
export class PasswordResetEmailComponent implements OnInit {
	constructor(private ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {
		this.Username = this.dialogConfig.data.Username;
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	errorMessage: any = "";
	Username: any = "";
	Email: any = "";

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////

	//INSERT CUSTOM BUTTON METHODS
	onFinish() {
		this.errorMessage = "";

		if (this.Email == null || String(this.Email).trim() == "") {
			this.errorMessage = "Enter an email to send a password reset email";
			return;
		}

		this.ref.close({
			Send: true,
			Email: this.Email,
		});
	}
	onClose() {
		this.ref.close({
			Send: false,
			Email: "",
		});
	}
	///////////////////////////////////////
}
